import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { DsButtonComponent } from '@design-system/ds-button/component/ds-button.component';
import { DsDatepickerComponent } from '@design-system/ds-datepicker/component/ds-datepicker.component';
import { DsInputComponent } from '@design-system/ds-input/component/ds-input.component';
import { DsSelectComponent } from '@design-system/ds-select/component/ds-select.component';
import { DsTextareaComponent } from '@design-system/ds-textarea/component/ds-textarea.component';
import { OnlyTimeDirective } from '@directives/only-time.directive';
import {
  SERVICE_REQUEST_FLAG_CATEGORY_OPTIONS,
  SERVICE_REQUEST_FLAG_REASON_MAX_LENGTH,
} from '@modals/service-request-flags/properties/service-request-flag.properties';
import { ServiceRequestFlagFormType } from '@modals/service-request-flags/types/service-request-flag-form.type';

@Component({
  selector: 'app-flag-form',
  templateUrl: './flag-form.component.html',
  styleUrls: ['./flag-form.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    ReactiveFormsModule,
    MatInputModule,
    OnlyTimeDirective,
    DsButtonComponent,
    DsDatepickerComponent,
    DsInputComponent,
    DsSelectComponent,
    DsTextareaComponent,
  ],
})
export class FlagFormComponent {
  @Input() form: ServiceRequestFlagFormType;
  @Input() isUpdateFlag = false;
  @Input() isSaving = false;

  @Output() readonly save = new EventEmitter<void>();
  @Output() readonly cancel = new EventEmitter<void>();

  readonly categoryOptions = SERVICE_REQUEST_FLAG_CATEGORY_OPTIONS;
  readonly reasonMaxLength = SERVICE_REQUEST_FLAG_REASON_MAX_LENGTH;

  /**
   * Submits the form on Enter. Text areas, buttons and opened controls keep their own Enter behavior.
   * @param event - The keyboard event from the form.
   */
  onFormEnter(event: Event): void {
    const target = event.target as HTMLElement;
    if (event.defaultPrevented || target.tagName === 'TEXTAREA' || target.tagName === 'BUTTON') {
      return;
    }
    event.preventDefault();
    this.save.emit();
  }
}
